import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { RouteTemplates } from '../navigation/routes';
import Account from '../account/Account';
import CustomerService from '../customerService/CustomerService';
import ReportRecipientDashboard from './ReportRecipientDashboard';
import ReportRecipientAggregateDashboard from './ReportRecipientAggregateDashboard';
import { useDispatch } from 'react-redux';
import { useCurrentUser } from '../auth/hooks';
import { logOutAction } from '../auth/login/api/logoutAction';
import { useWindowSize } from '../core/hooks/useWindowSize';
import { useMount } from '../core/hooks/useMount';
import { PortalType } from '../navigation/portalType';
import { setPortalTypeAction } from '../core/redux/setPortalTypeAction';
import ChangePasswordModal from '../account/ChangePasswordModal';
import ChangeSecurityQuestionModal from '../account/ChangeSecurityQuestionModal';


/**
 * ReportRecipientRouter: a component that routes to pages in the report recipient portal experience.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ReportRecipientRouter: React.FC = () => {
  const { isMobile } = useWindowSize();
  const dispatch     = useDispatch();
  const currentUser  = useCurrentUser();

  useMount(() => { dispatch(setPortalTypeAction(PortalType.REPORT_RECIPIENT)); });

  if (!currentUser?.hasReportRecipientLoginPermission) {
    dispatch(logOutAction(isMobile));
  }

  return (
    <>
      <Switch>
        <Route path={RouteTemplates.ReportRecipientAccountConfig} component={Account} />
        <Route path={RouteTemplates.ReportRecipientCustomerService} component={CustomerService} />
        <Route path={RouteTemplates.ReportRecipientChangePassword} component={ChangePasswordModal} />
        <Route path={RouteTemplates.ReportRecipientChangeSecurityQuestion} component={ChangeSecurityQuestionModal} />
        <Route path={RouteTemplates.ReportRecipientDashboard} component={ReportRecipientDashboard} />
        <Route path={RouteTemplates.ReportRecipientAggregateDashboard} component={ReportRecipientAggregateDashboard} />
      </Switch>
    </>
  );
};

export default ReportRecipientRouter;
